import { fetchWithToken } from '../../../api/apiutils';

export const searchLots = async (filters = {}) => {
  try {
    const response = await fetchWithToken('/api/lots', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => 'Ошибка сервера');
      throw new Error(`Ошибка запроса лотов: ${errorText}`);
    }

    return await response.json();
  } catch (err) {
    console.error('searchLots error:', err);
    throw err;
  }
};
